export enum Backlink {
	MONITORING_CENTER = 'monitoringCenter',
}
